import { some } from '@utils/some';
import { MultiRoomSearch } from 'shared-types';

export const getCommonItemsFromAvailability = <T extends { id: string; quantity: number | null }>(
  availability: T[][],
  roomConfigs: MultiRoomSearch,
  filterByQuantity = true
) => {
  const [firstArray, ...restArrays] = availability;
  if (!firstArray) return [];

  return firstArray.filter((item) => {
    const existsInAllArrays = restArrays.every((array) =>
      some(array, (element) => element.id === item.id)
    );
    const hasEnoughQuantity =
      !filterByQuantity || !item.quantity || item.quantity >= roomConfigs.length;

    return existsInAllArrays && hasEnoughQuantity;
  });
};
